import script from "./Demo.vue?vue&type=script&setup=true&lang=js"
export * from "./Demo.vue?vue&type=script&setup=true&lang=js"

import "./Demo.vue?vue&type=style&index=0&id=f9a05a8a&lang=css"

const __exports__ = script;

export default __exports__